import React from "react";
import AdminFormField from "../../components/Admin/AdminFormField";
import "../../styles/Admin.css";

const PricingForm = ({ config, onChange, saving }) => {
  if (!config) return null;

  const setField = (key, value) => {
    onChange({ ...config, [key]: value });
  };

  return (
    <div className="admin-form">
      <AdminFormField
        label="USD to INR Conversion Rate"
        type="number"
        step="0.01"
        value={config.usdToInr}
        onChange={(v) => setField("usdToInr", Number(v))}
        helperText="Exchange rate for converting USD to INR"
      />
      <AdminFormField
        label="Droplet Margin (%)"
        type="number"
        step="0.01"
        value={config.dropletMarginPct}
        onChange={(v) => setField("dropletMarginPct", Number(v))}
        helperText="Percentage markup on droplet pricing"
      />
      <AdminFormField
        label="Backup Margin (%)"
        type="number"
        step="0.01"
        value={config.backupMarginPct}
        onChange={(v) => setField("backupMarginPct", Number(v))}
        helperText="Percentage markup on backup pricing"
      />
      <AdminFormField
        label="Snapshot Margin (%)"
        type="number"
        step="0.01"
        value={config.snapshotMarginPct}
        onChange={(v) => setField("snapshotMarginPct", Number(v))}
        helperText="Percentage markup on snapshot pricing"
      />
      <AdminFormField
        label="Backup Base % of Droplet"
        type="number"
        step="0.01"
        value={config.backupBasePctOfDroplet}
        onChange={(v) => setField("backupBasePctOfDroplet", Number(v))}
        helperText="Base backup cost as percentage of droplet cost"
      />
      <AdminFormField
        label="Snapshot per GB (USD)"
        type="number"
        step="0.01"
        value={config.snapshotPerGbUsd}
        onChange={(v) => setField("snapshotPerGbUsd", Number(v))}
        helperText="Cost per GB for snapshots in USD"
      />
    </div>
  );
};

export default PricingForm;
